export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13 11.321l5.57 3.857a1 1 0 01.07 1.59l-6 5A1 1 0 0111 21v-6.938l-5.43 3.76-1.14-1.644L10.466 12 4.43 7.822l1.138-1.644L11 9.937V3h2v8.321zm0 7.543l3.349-2.79L13 13.753v5.11z\" fill=\"#7B61FF\"/><path d=\"M17.5 1v5h-2V1h2zM16.5 11a1.5 1.5 0 100-3 1.5 1.5 0 000 3z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};